import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import {
    FacebookFilled,
    ViberFilled,
    YoutubeFilled,
    TelegramFilled,
    CallOutlined,
} from "@assets";
import { useTranslation } from 'react-i18next';
import { Space } from 'antd';

const Container = styled.div`
position: absolute;
bottom: 0;
padding: 16px 0;

display: flex;
justify-content: center;
align-items: center;

width: 100%;
background-color: #fff;
`;

const Socials = styled.div`
flex: 0.5;
width: 100%;
padding: 0 0 16px 16px;
display: flex;
flex-direction: column;
gap: 12px;
align-items: flex-start;
justify-content: flex-start;
`;

const Contacts = styled.div`
flex: 0.5;
display: flex;
gap: 12px;
flex-direction: column;
align-items: flex-start;
justify-content: flex-start;

>.ant-space {
    gap: 3px !important;
    flex-direction: column !important;
    align-items: flex-start !important;
}

a {
    text-decoration: none !important;
}
`;

const BoldText = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #616161;

@media screen and (max-width: 375px) {
font-size: 14px;
}

@media screen and (max-width: 320px) {
font-size: 13px;
}
`;

const ContactText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #1E1E1E;
`;

const SocialText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #1E1E1E;
`;

const SocialBox = styled.div`
display: flex;
align-items: center;
gap: 8px;

a {
    display: flex;
}

svg {
    width: 35px;
    height: 35px;
}

@media screen and (max-width: 375px) {
    svg {
        width: 30px;
        height: 30px;
    }  
}

@media screen and (max-width: 320px) {
    svg {
        width: 25px;
        height: 25px;
    }  
}
`;

const SocialsBox = () => {
    const { t } = useTranslation();
    const { settings: { social_links } } = useSelector(state => state.app);

    const Link = ({ url, children }) => (
        <a href={url} target="_blank" rel="noreferrer noopen">
            {children}
        </a>
    );

    return (
        <Container>
            <Socials>
                <SocialText>
                    {t("home.appDownloadSubTitle1")}
                </SocialText>
                <SocialBox>
                    <Link url={social_links?.fb_link}>
                        <FacebookFilled />
                    </Link>
                    <Link url={social_links?.viber_link}>
                        <ViberFilled />
                    </Link>
                    <Link url={social_links?.telegram_link}>
                        <TelegramFilled />
                    </Link>
                    <Link url={social_links?.youtube_link}>
                        <YoutubeFilled />
                    </Link>
                </SocialBox>
            </Socials>
            <Contacts>
                <ContactText>
                    {t("message.contactTitle")}
                </ContactText>
                <Space>
                    <a href={`tel:${social_links?.phones[0]}`}>
                        <Space>
                            <CallOutlined />
                            <BoldText>{social_links?.phones[0]}</BoldText>
                        </Space>
                    </a>
                    <a href={`tel:${social_links?.phones[1]}`}>
                        <Space>
                            <CallOutlined />
                            <BoldText>{social_links?.phones[1]}</BoldText>
                        </Space>
                    </a>
                </Space>
            </Contacts>
        </Container>
    );
}

export default SocialsBox;